import * as onPointerLeave from './onPointerLeave.js';

export function pointerLeave() {
  onPointerLeave.onPointerLeave(this);
}
